import { useEffect } from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { SOCIAL_LINKS, isSocialPlatform } from "@/lib/socialLinks";

const SocialRedirect = () => {
  const { platform } = useParams();
  const isValidPlatform = isSocialPlatform(platform);
  const social = isValidPlatform ? SOCIAL_LINKS[platform] : null;

  useEffect(() => {
    if (!social) return;

    const timeoutId = window.setTimeout(() => {
      window.location.replace(social.external);
    }, 80);

    return () => window.clearTimeout(timeoutId);
  }, [social]);

  if (!social) {
    return <Navigate to="/" replace />;
  }

  return (
    <main className="min-h-screen bg-background text-foreground flex items-center justify-center px-6">
      <section className="w-full max-w-md rounded-3xl border border-border bg-card p-8 text-center shadow-lg">
        <p className="font-display text-3xl font-semibold text-foreground">Opening {social.label}</p>
        <p className="mt-3 font-body text-sm leading-relaxed text-muted-foreground">
          If your browser doesn&apos;t redirect automatically, use the button below.
        </p>
        <a
          href={social.external}
          className="mt-6 inline-flex min-h-11 items-center justify-center rounded-full bg-primary px-6 py-3 font-body text-sm font-semibold text-primary-foreground transition-opacity hover:opacity-90"
        >
          Continue to {social.label}
        </a>
        <Link
          to="/"
          className="mt-4 block font-body text-sm text-muted-foreground transition-colors hover:text-foreground"
        >
          Back to homepage
        </Link>
      </section>
    </main>
  );
};

export default SocialRedirect;
